import { IScope } from "angular";
import { IGoal } from "../models";
import { GoalService } from "../goalService";

interface IGoalTimelineScope extends IScope {
  goal: IGoal;
}

export interface IGoalTimelineParams {
  id: string;
}

export class GoalTimelineCtrl {
  public static $inject = ["$scope", "GoalService", "$stateParams"];

  constructor(private $scope: IGoalTimelineScope, private goalService: GoalService, private $stateParams: IGoalTimelineParams) {
    this.loadGoal();
  }

  private loadGoal = () => {
    this.goalService.getGoal(this.$stateParams.id).then((goal) => {
      this.$scope.goal = goal;
    });
  };
}
